export default "__VITE_PUBLIC_ASSET__06d1cf07__"